function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M9.77967 3.60875C10.772 1.90837 13.2287 1.90837 14.2211 3.60875L22.4857 17.7757C23.4851 19.4898 22.2484 21.6427 20.264 21.6429H3.7367C1.7521 21.6429 0.515194 19.49 1.51502 17.7757L9.77967 3.60875ZM12.4935 4.61657C12.273 4.23911 11.7278 4.23911 11.5072 4.61657L3.24256 18.7836C3.02041 19.1646 3.29574 19.6429 3.7367 19.6429H20.264C20.7045 19.6427 20.98 19.1645 20.7582 18.7836L12.4935 4.61657ZM12.0004 15.7142C12.7693 15.7144 13.3928 16.3377 13.3929 17.1068C13.3929 17.8761 12.7694 18.5002 12.0004 18.5004H11.9994C11.2305 18.5 10.6068 17.876 10.6068 17.1068C10.607 16.3378 11.2306 15.7146 11.9994 15.7142H12.0004ZM12.0004 7.8568C12.5524 7.85701 13.0002 8.3048 13.0004 8.8568V13.9642C13.0002 14.5163 12.5524 14.964 12.0004 14.9642C11.4482 14.9642 11.0005 14.5164 11.0004 13.9642V8.8568C11.0006 8.30468 11.4482 7.8568 12.0004 7.8568Z"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.dba47652.svg";
export { ForwardRef as ReactComponent };